export const CONNECTIVITY_UI_OFFLINE_GRACE_MS = 3000;
